import { type FC } from 'react';
import cn from 'classnames';

import { useCurrentLotteryTier } from '../../hooks';

import css from './styles.module.scss';

const SideEffects: FC = () => {
  const currentTicketType = useCurrentLotteryTier();

  return (
    <>
      <span
        className={cn(
          css.sideEffect,
          css['sideEffect--left'],
          css[`sideEffect--${currentTicketType}`],
        )}
      ></span>
      <span
        className={cn(
          css.sideEffect,
          css['sideEffect--right'],
          css[`sideEffect--${currentTicketType}`],
        )}
      ></span>
    </>
  );
};

export { SideEffects };
